var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'gt-datagrid',
    _vm.hasBorder ? 'border' : '',
    _vm.hasBottomMargin24 ? 'marginB' : '',
    _vm.hasTopMargin18 ? 'marginT18' : '',
    _vm.isViewMode ? 'gt-datagrid__viewmode' : ''
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }